import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const useResultsHL7OrderDetails = (orderId, { enabled = true } = {}) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["HL7Details", orderId, tenantVal],
    queryFn: async () => {
      if (!orderId || !tenantVal) return null;
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/healthlink/common/results/details/${orderId}`
      );

      return response.data;
    },
    enabled: enabled && !!orderId && !!tenantVal,
    meta: { errorMessage: "Error fetching HL7 details" },
  });
};

export { useResultsHL7OrderDetails };